e4.gtm = {
    debug: false,
    init: function () {
        if ( window.dataLayer !== undefined ) {
            e4.gtm.bindEvents();
        }
        else{
            e4.util.debug( [
                'window.google_tag_manager = ',
                window.google_tag_manager,
                'Not binding anything.'
            ], e4.gtm.debug );
        }
    },
    bindEvents: function () {
        jQuery( document )
            .on( 'userauthenticated.e4.login', e4.gtm.login )
            .on( 'productadded.e4.cart', e4.gtm.ecom.addProduct )
            .on( 'orderlinedeleted.e4.cart', e4.gtm.ecom.removeProduct );
        jQuery( '.js-e-search-form' )
            .on( 'loaded.e4.search', e4.gtm.search );
        jQuery( '.js-e-checkout, .js-e-checkout-receipt' )
            .on( [
                'stepchanged.e4.checkout',
                'receiptshown.e4.checkout'
            ].join( ' ' ), e4.gtm.ecom.checkoutStep );
    },
    pushDataLayer: function ( objDataLayer ) {
        if ( window.dataLayer !== undefined ) {
            dataLayer.push( objDataLayer );
        }
        else{
            e4.util.debug( [
                'window.dataLayer = ',
                window.dataLayer,
                'Not pushing anything.'
            ], e4.gtm.debug );
        }
    },
    login: function () {
        /* GA OLD
        e4.gtm.pushDataLayer( {
            'LoggedOn': 'OK',
            'event': 'LoggedOnDone'
        } );
        */
        /* GA4 */
        e4.gtm.pushDataLayer( {
            'event': 'login',
            'method': 'userId'
        } );

    },
    search: function ( event, objData ) {
        /* GA OLD
        e4.gtm.pushDataLayer( {
            'event': 'VirtualPageviewSearch',
            'virtualPageSearchURL': '/search?q=' + objData.query,
            'virtualPageSearchTitle': 'Search'
        } );
        if ( objData.resultCount === 0 ) {
            e4.gtm.pushDataLayer( {
                'eventCategory': 'Search - Zero results',
                'eventAction': objData.query,
                'eventLabel': '{{Page URL}}',
                'eventValue': 0,
                'eventInteraction': true,
                'event': 'track-ga-event'
            } );
        }
        */
        
        /* GA4 */
        e4.gtm.pushDataLayer( {
            'event': 'search',
            'search_term': objData.query
        } );
        if ( objData.resultCount === 0 ) {
            e4.gtm.pushDataLayer( {
                'ga4EventName': 'Zero-search',
                'ga4EventParameter1': objData.query,
                'event': 'track-ga4-event'
            } );
        }

    },
    ecom: {
        // https://developers.google.com/tag-manager/enhanced-ecommerce#cart
        addProduct: function ( event, objData ) {
            // console.log( 'GTM: Add product', objData );
            /* GA OLD
            e4.gtm.pushDataLayer( {
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': objData.cart.currencyCode,
                    'add': {
                        'products': [
                            {
                                'name': objData.cart.lastAdded[ 0 ].name,
                                'id': objData.cart.lastAdded[ 0 ].number,
                                'price': objData.cart.lastAdded[ 0 ].priceClean,
                                'quantity': objData.cart.lastAdded[ 0 ].quantity
                            }
                        ]
                    }
                }
            } );
            */
            
            /* GA4 */
            e4.gtm.pushDataLayer({
                event: 'add_to_cart', 
                ecommerce: {
                    items: [
                        {
                            item_id: objData.cart.lastAdded[ 0 ].number,
                            item_name: objData.cart.lastAdded[ 0 ].name,
                            currency: objData.cart.currencyCode,
                            price: objData.cart.lastAdded[ 0 ].priceClean,
                            quantity: objData.cart.lastAdded[ 0 ].quantity
                        }
                    ]
                }
            });
        },
        removeProduct: function ( event, objData ) {
            // console.log( 'GTM: Remove product', objData );
            /* GA OLD
            e4.gtm.pushDataLayer( {
                'event': 'removeFromCart',
                'ecommerce': {
                    'currencyCode': objData.currencyCode,
                    'remove': {
                        'products': [
                            {
                                'name': objData.name,
                                'id': objData.number,
                                'price': objData.price,
                                'quantity': objData.quantity
                            }
                        ]
                    }
                }
            } );
            */
            /* GA4 */
            e4.gtm.pushDataLayer( {
                event: 'remove_from_cart',
                ecommerce: {
                    items: [
                        {
                            item_id: objData.number,
                            item_name: objData.name,
                            currency: objData.currencyCode,
                            price: objData.price,
                            quantity: objData.quantity
                        }
                    ]
                }
            });

        },
        checkoutStep: function ( event, objData ) {
            // e4 checkout index is zero based, so we bump up index to honor GA's flow which begins at one.
            var intCheckoutStepIndexForGA = parseInt( objData.index ) + 1;
            e4.util.debug( [
                'checkoutStep objData',
                objData,
                'intCheckoutStepIndexForGA',
                intCheckoutStepIndexForGA
            ], e4.gtm.debug );
            if ( intCheckoutStepIndexForGA > 0 && objData.name !== '' ) {
                var objVirtualPageview = {
                        'event': 'VirtualPageview',
                        'vpevent': 'VirtualPageview',
                        'virtualPageURL': '/shop/cart/checkout?step=' + intCheckoutStepIndexForGA + ' ' + objData.name,
                        'virtualPageTitle': 'Order Step ' + intCheckoutStepIndexForGA + ' – ' + objData.name
                    },
                    objCheckout = {
                        'event': 'checkout',
                        'ecommerce': {
                            'checkout': {
                                'actionField': {
                                    'step': intCheckoutStepIndexForGA
                                }
                            }
                        }
                    };
                e4.gtm.pushDataLayer( objVirtualPageview );
                e4.gtm.pushDataLayer( objCheckout );
            }
        }
    }
};
